import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { request } from "@/lib/coachQueries";

/**
 * Master v5 Prompt 29 — Audit Import review UI. AuditReport +
 * WorkspaceAuditImport remain the sole source of truth (Prompt 27); these
 * hooks are read/decide access only, no client mutation of Audit data.
 */

// Coach: every WorkspaceAuditImport in one Workspace (Client 360 filters by memberId itself).
export function useWorkspaceAuditImports(workspaceId) {
  return useQuery({
    queryKey: ["audit-imports", workspaceId],
    enabled: !!workspaceId,
    queryFn: () => request(`/api/rehearsal-room/workspaces/${workspaceId}/audit-imports`),
  });
}

// Coach: accept / partially_accept / dismiss a pending_review import.
export function useDecideAuditImport(workspaceId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ waiId, decision, note }) =>
      request(`/api/rehearsal-room/workspaces/${workspaceId}/audit-imports/${waiId}/decision`, {
        method: "POST",
        body: JSON.stringify({ decision, note: note ?? null }),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["audit-imports", workspaceId] });
      qc.invalidateQueries({ queryKey: ["coach-today"] });
      qc.invalidateQueries({ queryKey: ["coach-audit-imports-overview"] });
    },
  });
}

// Coach, cross-Workspace: light summary for the Files workbench banner.
export function useCoachAuditImportsOverview() {
  return useQuery({
    queryKey: ["coach-audit-imports-overview"],
    queryFn: () => request(`/api/rehearsal-room/coach/audit-imports`),
  });
}

// Client, self-scoped: own accepted/partially_accepted Audit Result Report(s) only.
export function useMyAuditResults(workspaceId) {
  return useQuery({
    queryKey: ["my-audit-results", workspaceId],
    enabled: !!workspaceId,
    queryFn: () => request(`/api/rehearsal-room/workspaces/${workspaceId}/my-audit-results`),
  });
}
